import React from "react";
import Text from "../Text";

export default function PriceDisplay({
  currentPriceLabel,
  currentPriceValue,
  ...props
}: {
  currentPriceLabel?: string;
  currentPriceValue?: string;
  [key: string]: any;
}) {
  return (
    <div {...props} className={`${props.className} pixel-price-container relative`}>
      {/* Main white background box with pixel borders */}
      <div className="pixel-price-box flex flex-col items-center justify-center p-4 bg-white-a700">
        <div className="pixel-price-inner-border"></div>
        <Text
          as="p"
          className="text-[20px] font-normal font-upheavalttbrk font-upheaval mb-2 z-10"
          style={{ color: "#000", fontSize: '1.5em' }}
        >
          {currentPriceLabel || "CURRENT PRICE"}
        </Text>
        <Text
          as="p"
          className="text-[28px] font-normal font-upheavalttbrk font-upheaval z-10"
          style={{ color: "#5d8b94", fontSize: '2em' }}
        >
          {currentPriceValue || "$132.63"}
        </Text>
      </div>
    </div>
  );
}
